export const getFileExtension = path => path.split('.').pop()

export const mergeFiles = items =>
  items.map(item => {
    const { uniqueFile, documents, ...attributes } = item

    const singleFile = uniqueFile || {}
    const fileSet = documents || []
    const files = [singleFile, ...fileSet].filter(file => file?.file)

    return { ...attributes, files }
  })
